export const initialWidth = '0%';
export const animationDelayMs = 150;
